// Tiny className combiner (no extra deps). Filters falsy values and joins.
export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default cn;
